import { render, staticRenderFns } from "./rds-page.vue?vue&type=template&id=16271862&scoped=true&"
import script from "./rds-page.vue?vue&type=script&lang=js&"
export * from "./rds-page.vue?vue&type=script&lang=js&"
import style0 from "./rds-page.vue?vue&type=style&index=0&id=16271862&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16271862",
  null
  
)

export default component.exports